import styled from 'styled-components';

const FIGMA_FONT = `'Segoe UI', sans-serif`;

type StatusMessageStyleProps = {
    $status: 'success' | 'pending' | 'error'
}

const StatusMessageContainer = styled.div<StatusMessageStyleProps>`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: ${props => props.$status === 'error' ? '1.25rem 2rem 0.75rem' : '3rem 0 1.25rem'};
    gap: ${props => props.$status === 'error' ? '9px' : '0'};

    @media (max-width: ${(props) => props.theme.breakpoints.md}) {
        padding: ${props => props.$status === 'error' ? '1rem 1rem 0.5rem' : '1rem'};
    }
`

type StatusIconProps = {
    color: string
}


const StatusIcon = styled.div<StatusIconProps & StatusMessageStyleProps>`
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 0;

    svg {
        fill: ${props => props.$status === 'success' ? 'none' : (props.color || 'inherit')};
        width: ${props => props.$status === 'error' ? '75px' : 'auto'};
        height: ${props => props.$status === 'error' ? '75px' : 'auto'};
    }
`

const StatusMessageTitle = styled.h1<StatusMessageStyleProps>`
    margin: 0;
    text-align: center;
    color: ${props => props.$status === 'error' ? '#000000' : '#222222'};
    font-family: ${props => props.$status === 'error' ? FIGMA_FONT : 'inherit'};
    font-style: normal;
    font-weight: ${props => props.$status === 'error' ? 400 : 600};
    font-size: ${props => props.$status === 'error' ? '36px' : '2.25rem'};
    line-height: ${props => props.$status === 'error' ? '100%' : '1.2'};
    letter-spacing: 0;

    @media (max-width: ${(props) => props.theme.breakpoints.sm}) {
        font-size: ${props => props.$status === 'error' ? '26px' : '2rem'};
        line-height: ${props => props.$status === 'error' ? '100%' : '1.2'};
    }
`

const StatusMessageDescription = styled.div<StatusMessageStyleProps>`
    margin: 15px 0 0;
    text-align: center;
    width: ${props => props.$status === 'error' ? '100%' : '30%'};
    max-width: ${props => props.$status === 'error' ? '656px' : 'none'};
    color: ${props => props.$status === 'error' ? '#000000' : 'inherit'};
    font-family: ${props => props.$status === 'error' ? FIGMA_FONT : 'inherit'};
    font-style: normal;
    font-weight: ${props => props.$status === 'error' ? 400 : 500};
    font-size: ${props => props.$status === 'error' ? '24px' : '1rem'};
    line-height: ${props => props.$status === 'error' ? '100%' : '1.5'};
    letter-spacing: 0;

    @media (max-width: ${(props) => props.theme.breakpoints.md}) {
        width: 100%;
    }

    @media (max-width: ${(props) => props.theme.breakpoints.sm}) {
        font-size: ${props => props.$status === 'error' ? '16px' : '1rem'};
        line-height: ${props => props.$status === 'error' ? '100%' : '1.5'};
    }
`


export { StatusMessageContainer, StatusIcon, StatusMessageTitle, StatusMessageDescription }
